var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlorious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 39") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60,27.22a1,1,0,0,0,0-.11.9.9,0,0,0-.05-.44s0,0,0-.07v0l-7-14A1,1,0,0,0,52,12H12a1,1,0,0,0-.89.55l-7,14v0s0,0,0,.07a1,1,0,0,0-.05.44,1,1,0,0,0,0,.11,1,1,0,0,0,0,.15l0,.1,0,0,.08.09,0,.06,27,29a1,1,0,0,0,1.46,0l27-29,0-.06.08-.09,0,0,0-.1A1,1,0,0,0,60,27.22ZM57.38,26H45.67l6.06-11.31ZM33,16.21,41.82,26H32.93ZM30.93,26h-8L31,16.7Zm12.89-.77L33.68,14H49.83Zm-22.95.08L13.7,14h17ZM30.92,28,30.8,49.2,22.47,28Zm2,0h9.61L32.79,50.64ZM12.05,15.13,18.93,26H6.62ZM20.32,28l9.51,24.2L7.3,28ZM34.4,52,44.7,28h12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlorious);
export default __webpack_public_path__ + "static/media/glorious.0f806739a2faf9b07fc8edb73c52399e.svg";
export { ForwardRef as ReactComponent };